import { useEffect, useState } from "react";
import { fetchUserAttributes } from "aws-amplify/auth";

function useUserAttributes(user) {
    const [userAttributes, setUserAttributes] = useState(undefined);

    const refreshUserAttributes = async () => {
        setUserAttributes(undefined);

        if (user) {
            fetchUserAttributes()
                .then(setUserAttributes)
                .catch(console.error);
        }
    }

    useEffect(() => {
        refreshUserAttributes();
    }, [user]);

    return { userAttributes, refreshUserAttributes };
}

export default useUserAttributes;